var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-between h-[72px] border-b-[1px] border-border py-[4px]"},[_c('div',{staticClass:"flex items-center gap-x-[12px] px-[0px]"},[_c('div',{staticClass:"rounded-[8px] bg-gray-200 w-[48px] h-[48px] animate-pulse"}),_c('div',{staticClass:"flex-1 h-[24px] bg-gray-200 rounded animate-pulse"})])])
}]

export { render, staticRenderFns }